














































































































































































import {Component} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {Tabs, ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { MailNotifyDetailItem } from "@/store/mail_notify/statistic/types";
import {dateFilter} from "@/utils/date-util";
import { colorClassByStatus } from "@/utils/page-utils";
import MNDetailFilter from "@/components/MailNotify/Statistic/MNDetailFilter.vue";

@Component({
  components: {MNDetailFilter, Tabs, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class MNDetail extends BaseItemsPage<MailNotifyDetailItem> {

  @Getter("mailNotifyStaticDetail") responseItems!: MailNotifyDetailItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'create_date',
      "mn_service_name",
      "mn_tmpl",
      "routes",
      'recipient',
      "message",
      'error_code',
      'id',
      'message',
      'partner',
      'service_provider',
      'status',
      'message_category',
      'detail',
    ];
  }

  getData() {
    return this.responseItems;
  }
}
